/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { getLabel } from 'utils/widgetTypeUtil'
import WordCloud from '../../share/WordCloud'
import RunSearchEffect from '../../share/RunSearchEffect'
import { getMeasureByCountTypeAndAnalysisType } from '../../../../../utils/measureUtil'
import { TopicNotSelectedGuard, WidgetLoadingGuard } from '../../../share/guards'
import WordCloudWidgetDataGuards from '../../share/guards/WordCloudWidgetDataGuards'
import { SocialWebSentimentDriversWidget } from '../../../../../schemas/SocialWebSentimentDriversWidgetSchema'
import InsightModal from '../../share/InsightModal'
import useSelectedInsights from '../../hooks/useSelectedInsights'

const WordCloudDisplay = ({
  widgetId,
  widgetSetting
}: {
  widgetId: number
  widgetSetting: SocialWebSentimentDriversWidget
}) => {
  const {
    isModalOpen,
    setIsModalOpen,
    selection,
    countType,
    detailSetting,
    handleWordCloudClick,
    widgetSettingWithSelection
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <RunSearchEffect
          widgetId={widgetId}
          measure={getMeasureByCountTypeAndAnalysisType(
            widgetSetting.countType!,
            widgetSetting.analysisType!
          )}>
          <WidgetLoadingGuard widgetId={widgetId}>
            <WordCloudWidgetDataGuards widgetId={widgetId}>
              <WordCloud widgetId={widgetId} onClick={handleWordCloudClick} />
            </WordCloudWidgetDataGuards>
          </WidgetLoadingGuard>
        </RunSearchEffect>
      </TopicNotSelectedGuard>
      <InsightModal
        widgetSettingWithSelection={widgetSettingWithSelection}
        open={isModalOpen}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={countType}
        selection={selection}
        onClose={() => {
          setIsModalOpen(false)
        }}
        detailSetting={detailSetting}
      />
    </UnexpectedErrorBoundary>
  )
}
export default WordCloudDisplay
